module.exports = __webpack_public_path__ + "static/media/resume.7c6d3de2.pdf";